import './App.css';
import {
  createBrowserRouter,
  RouterProvider,
  Outlet,
} from "react-router-dom";
import ScrollToTop from '../components/ScrollToTop';
import Login from '../pages/auth/login';
import Register from '../pages/auth/registration';
import BarcodeExpandedStacked from '../pages/barcodeExpandedStacked/barcodeExpandedStacked';
import BarcodeWizard from '../pages/barcodeExpandedStacked/BarcodeWizard';
import CompanyPrefixes from '../pages/companyPrefixes/companyPrefixes';
import QrCode from '../pages/qrCode/qrCode';
import Gs1128Code from '../pages/gs1128Code/gs1128Code';
import ForgotPassword from '../pages/auth/forgot-password';
import ResetPassword from '../pages/auth/reset-password';
import Coupons from '../pages/coupons/Coupons';
import Landing from '../pages/landing/Landing';
import Services from '../pages/services/Services';
import GetStarted from '../pages/getStarted/GetStarted';
import { ProductCategory } from '../pages/productCategory/ProductCategory';
import { Manufacturers } from '../pages/manufacturers/Manufacturers';
import { ManufacturerCoupon } from "../pages/manufacturerCoupon/ManufacturerCoupon"
import { Profile } from '../pages/profile/Profile';
import { CouponUsage } from '../pages/coupon-usage/CouponUsage';
import { NotFound } from '../pages/notFound/NotFound';
import { CreateCoupon } from '../pages/createCoupon/CreateCoupon';
import { PaymentSuccess } from '../pages/payment/PaymentSuccess';
import { PaymentCancel } from '../pages/payment/PaymentCancel';
import PrivacyPolicy from '../pages/privacyPolicy/PrivacyPolicy';

const getUser = () => {
  return localStorage.getItem("user");
}

function Layout() {
  return (
    <>
      <ScrollToTop />
      <Outlet />
    </>
  );
}

const router = createBrowserRouter([
  {
    element: <Layout />,
    children: [
      {
        path: "/",
        element: <Landing />,
      },
      {
        path: "/services",
        element: <Services />,
      },
      {
        path: "/get-started",
        element: <GetStarted />,
      },
      {
        path: "/login/:return",
        element: <Login />,
      },
      {
        path: "/register",
        element: <Register />,
      },
      {
        path: "/forgot-password",
        element: <ForgotPassword />,
      },
      {
        path: "/reset-password",
        element: <ResetPassword />,
      },
      {
        path: "/barcode/:return",
        element: <BarcodeWizard />,
        loader: getUser,
      },
      {
        path: "/barcode-wizard/:return",
        element: <BarcodeWizard />,
        loader: getUser,
      },
      {
        path: "/qrcode/:return",
        element: <QrCode />,
        loader: getUser,
      },
      {
        path: "/gs1128code/:return",
        element: <Gs1128Code />,
        loader: getUser,
      },
      {
        path: "/companyprefixes/:return",
        element: <CompanyPrefixes />,
        loader: getUser,
      },
      {
        path: "/productcategory/:return",
        element: <ProductCategory />,
        loader: getUser,
      },
      {
        path: "/coupons/:return",
        element: <Coupons />,
        loader: getUser,
      },
      {
        path: "/manufacturers/:return",
        element: <Manufacturers />,
        loader: getUser,
      },
      {
        path: "/manufacturer-coupon/:email",
        element: <ManufacturerCoupon />,
        loader: getUser,
      },
      {
        path: "/profile/:return",
        element: <Profile />,
        loader: getUser,
      },
      {
        path: "/coupons-usage/:userId",
        element: <CouponUsage />,
        loader: getUser,
      },
      {
        path: "/create-coupon",
        element: <CreateCoupon />,
        loader: getUser,
      },
      {
        path: "/payment/success",
        element: <PaymentSuccess />,
      },
      {
        path: "/payment/cancel",
        element: <PaymentCancel />,
      },
      {
        path: "/privacy-policy",
        element: <PrivacyPolicy />,
      },
      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

function App() {
  // Disable browser's automatic scroll restoration
  if ('scrollRestoration' in window.history) {
    window.history.scrollRestoration = 'manual';
  }

  document.addEventListener("wheel", function (event) {
    if (document.activeElement.type === "number") {
      document.activeElement.blur();
    }
  });

  return (
    <div className="App">
      <RouterProvider router={router} />
    </div>
  );
}

export default App;
